// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// NGRX & RXJS
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { filter, map, take, switchMap, catchError } from 'rxjs/operators';

// Miscellaneous
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { constants } from '../constants/constants';
import { LoaderService } from '../modules/loading/loader.service';
import { ErrorService } from '../modules/core/services/error.service';
import { HttpErrorResponse } from '@angular/common/http';

export const boardingPassGuard: CanActivateFn = (): Observable<boolean> => {
	let payload: any = null;
  const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const router: Router = inject(Router);
  const errorService: ErrorService = inject(ErrorService);
  const loader: LoaderService = inject(LoaderService);

  return store.pipe(
    select(fromRoot.getSessionState),
    filter(resData => resData.reservationRetrievalResp !== null || !!resData.error),
    take(1),
    switchMap(resData => {
      if (resData.error) {
        store.dispatch(new olci.NavigateToError());
        return of(false);
      }

      // get selected guest from session storage
      store
        .pipe(
          select(fromRoot.getEntitySelectedOther),
          take(1)
        )
        .subscribe(g => {
          if (!g) {
            return null;
          }
          payload = g.guestId !== null ? { guestId: g.guestId, bookingId: g.bookingId } : null;
        });

      if (!payload) {
        router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
        return of(false);
      }

      store.dispatch(new olci.GetSetSailpassAction([payload]));
      return store.pipe(
        select(fromRoot.getSetSailPassState),
        filter(setSailState => {
          return !!setSailState.loaded || !!setSailState.error;
        }),
        take(1),
        map(state => {
          if (state.error) {
            throw state.error;
          }

          if (state.boardingPassErrors.length) {
            loader.hideLoader();
            const message = state.boardingPassErrors.join(' - ');

            const response = {
              status: constants.HTTP_STATUS_CODE.BACKEND_ERROR,
              error: message,
              statusText: message
            } as HttpErrorResponse;

            errorService.setResponseError(response);
            return false;
          }

          return true;
        }),
        catchError(() => {
          return of(false);
        })
      );
    })
  );
}
